export enum PlayerTheme {
  White = 'white',
  Gray = 'gray-100',
  Primary = 'primary-light',
}
